class DynamicWidth {
	constructor(config) {
		this.config = Object.assign({
			scope: '',
			name: '',
			wrappers: ['body'],
			callback: null
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.setWidth();
		this.addEventlisteners();
	}

	addEventlisteners() {
		let observer = new ResizeObserver(this.setWidth.bind(this));
		observer.observe(this.$scope[0]);
	}

	setWidth() {
		this.timeout ? clearTimeout(this.timeout) : null;
		this.timeout = setTimeout(() => {
			let width = this.$scope.outerWidth();
			for(let key in this.config.wrappers) {
				let val = width + 'px';
				if(width <= 0) {
					val = '100%'
				}
				$(this.config.wrappers[key]).css(`--${this.config.name}`, val);

				if(this.config.callback) {
					this.config.callback();
				}
			}
		}, 200);
	}
}

export default DynamicWidth;
